import { render, staticRenderFns } from "./Plot2D.vue?vue&type=template&id=142dc8a7&"
import script from "./Plot2D.vue?vue&type=script&lang=js&"
export * from "./Plot2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports